export default {
	// 中文
	zh: [{
			key: '1001',
			value: '服务器繁忙'
		}, {
			key: '1004',
			value: '请求时间过期'
		}, {
			key: '1005',
			value: '数据错误'
		}, {
			key: '1006',
			value: '帐号或密码不正确'
		}, {
			key: '1009',
			value: '请登陆后操作'
		}, {
			key: '1014',
			value: '三小时后再登陆'
		}, {
			key: '1049',
			value: '该账号被禁用'
		}, {
			key: '1035',
			value: '帐号不存在'
		}, {
			key: '1033',
			value: '手机号码或密码不正确'
		}, {
			key: '1051',
			value: '不支持的第三方oauth平台'
		}, {
			key: '1052',
			value: '第三方oauth未认证成功'
		}, 
		// 自定义
		{
			key: '0001',
			value: '请确认验证码'
		},{
			key: '0002',
			value: '请输入6-12位密码'
		},{
			key: '0003',
			value: '请确认账号'
		},{
			key: '0004',
			value: '请输入账号'
		},{
			key: '0005',
			value: '请输入密码'
		},{
			key: '0006',
			value: '密码修改成功'
		},{
			key: '0007',
			value: '验证码限额（每天10次）已用完。'
		}
	],

	// 英语
	en: [{
			key: '服务器繁忙',
			value: 'Server is busy'
		}, {
			key: '请求时间过期',
			value: 'Request timeout'
		}, {
			key: '数据错误',
			value: 'Account or password error,Enter again'
		}, {
			key: '帐号或密码不正确',
			value: 'Account or password error,Enter again'
		}, {
			key: '请登陆后操作',
			value: 'Please sign in first'
		}, {
			key: '三小时后再登陆',
			value: 'Sign in after 3 hours'
		}, {
			key: '该账号被禁用',
			value: 'This account has been disabled'
		}, {
			key: '用户不存在',
			value: 'Account does not exist'
		}, {
			key: '手机号码或密码不正确',
			value: 'Mobile phone number or password incorrect'
		}, {
			key: '不支持的第三方oauth平台',
			value: 'Unsupported third party oauth platform'
		}, {
			key: '第三方oauth未认证成功',
			value: 'Third party oauth authentication failed'
		},
		// 自定义
		{
			key: '请确认验证码',
			value: 'Please check the verify code'
		},{
			key: '请输入6-12位密码',
			value: 'Please enter the password for 6-12 digits'
		},{
			key: '请确认账号',
			value: 'Please check the account'
		},{
			key: '请输入账号',
			value: 'Please enter the account'
		},{
			key: '请输入密码',
			value: 'Please enter the password'
		},{
			key: '密码修改成功',
			value: 'Your password has been modified successfully !'
		},{
			key: '验证码限额（每天10次）已用完',
			value: 'Verification code quota (10 times per day) has run out.'
		}
	],
}



//////////////////
// WEBPACK FOOTER
// ./static/js/config/msgs.js
// module id = SAZi
// module chunks = 7